<div class="grid grid-cols-2 items-center mb-6" *ngIf="showPrincipalAmount">
	<div class="text-grey-darker">Principal amount</div>
	<app-input
		[forceErrorState]="forceErrorState"
		[startIcon]="ICON.DOLLAR"
		[ngModel]="_mortgage?.amount"
		type="cents"
		(debounce)="setAmount($event)"
	></app-input>
</div>
<div class="flex mb-4 items-center justify-between">
	<div class="flex gap-4 items-center">
		<h5 class="mb-0">Deductions</h5>
		<div class="flex flex-col relative">
			<app-button
				[icon]="ICON.ADD"
				(clickOutside)="hideDropdown()"
				(onClick)="toggleDropdown()"
				size="small"
			>
				Add item
			</app-button>
			<app-dropdown-options
				[show]="showDropdownOptions"
				[itemGroups]="[{ items }]"
				(onSelect)="onSelect($event)"
				xposition="right"
				[dropdownClasses]="'max-h-60'"
				marginTop="10px"
			></app-dropdown-options>
		</div>
	</div>
	<div class="flex items-center text-grey text-sm">Less (-)</div>
</div>

<ul class="flex flex-col my-3 gap-4 overflow-auto py-2">
	<ng-container
		*ngFor="
			let item of _mortgage?.netAdvancedAmounts;
			let i = index;
			trackBy: itemsTrackBy
		"
	>
		<li
			class="grid grid-cols-2 gap-2"
			[ngClass]="isEditDescriptionList[i] ? 'items-start' : 'items-center'"
		>
			<div class="flex items-center gap-2">
				<app-button
					*ngIf="item.type !== lenderRetainedType && !isEditDescriptionList[i]"
					btn="tertiary"
					[icon]="ICON.DELETE"
					[holdable]="true"
					(onClick)="removeItem(i)"
				>
				</app-button>
				<app-button
					*ngIf="item.type === lenderRetainedType && !isEditDescriptionList[i]"
					btn="tertiary"
					[icon]="ICON.EDIT"
					(onClick)="editRetainedByLender(i)"
				>
				</app-button>
				<app-input
					*ngIf="isEditDescriptionList[i]; else itemDescription"
					class="flex-1"
					[(ngModel)]="item.description"
					[placeholder]="getPlaceholder(item.type)"
					[required]="true"
					[name]="'name-' + i"
					[submitted]="submitted"
				>
				</app-input>
				<ng-template #itemDescription>
					<span>{{ item.description }}</span>
				</ng-template>
			</div>
			<app-input
				type="cents"
				[startIcon]="ICON.DOLLAR"
				[required]="!item?.calculated"
				[ngModel]="calculateAmountDisplayValue(item.type, item.amount)"
				(ngModelChange)="item.amount = $event"
				(debounce)="isEditDescriptionList[i] ? '' : updateNetAdvancedAmounts()"
				[name]="'amount-' + i"
				[submitted]="submitted"
				[disabled]=""
				#amountInput
			>
			</app-input>
			<div class="flex justify-end gap-2" *ngIf="isEditDescriptionList[i]">
				<app-button
					btn="secondary"
					size="small"
					(onClick)="
						item.type === lenderRetainedType
							? cancelEditRetainedByLender()
							: removeItem(i)
					"
					>Cancel</app-button
				>
				<app-button
					btn="primary"
					(onClick)="onDescriptionSave(i, amountInput)"
					size="small"
					>Save</app-button
				>
			</div>
		</li>
	</ng-container>
</ul>

<div
	class="flex justify-end gap-1 mt-4 text-sm text-grey-darker items-center"
	*ngIf="_mortgage?.netAdvancedOverride"
>
	Auto-calculate retained by lender
	<atomic-switch
		size="sm"
		[ngModel]="isRetainedByLenderOn"
		(ngModelChange)="toggleRetainedByLenderSwitch($event)"
	></atomic-switch>
</div>

<div
	*ngIf="_mortgage?.transactionType !== transactionTypes.VTB; else Vtbcredit"
	class="flex flex-col bg-grey-veryLight pt-1.5 pb-2 mt-4 px-5 rounded"
>
	<div class="flex justify-between items-center">
		<div class="flex items-center">
			<h5>Net advance</h5>
		</div>
		<div class="flex items-center text-grey text-sm">Equals (=)</div>
	</div>

	<div class="grid grid-cols-2 items-center mt-6 gap-1">
		<div>Amount advanced to trust ledger</div>
		<div>
			<app-input
				[startIcon]="ICON.DOLLAR"
				[placeholder]="netAdvancedAmount?.total | centsToDollars"
				type="cents"
				[ngModel]="netAdvancedAmount?.total"
				class=""
				(debounce)="setOverride($event)"
			>
			</app-input>
		</div>
	</div>
	<div class="flex justify-end" *ngIf="_mortgage?.netAdvancedOverride">
		<app-button
			btn="link"
			cssClasses="text-sm p-0"
			(onClick)="toggleNetAdvanced()"
			>Set to calculated value</app-button
		>
	</div>
</div>

<ng-template #Vtbcredit>
	<ng-container *ngIf="showFinalCredit">
		<hr class="my-4 border-2" />
		<div class="flex justify-between" data-intercom-target="vtb-loan-details">
			<label class="font-bold"> VTB Credit To purchaser</label>
			<p>{{ netAdvancedAmount?.total | centsToDollars }}</p>
		</div>
	</ng-container>
</ng-template>
